declare namespace $ {

	type $shm_hitalama_components_demo__definition_shm_hitalama_map_widget_float_application_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_application['definition'] >
		,
		ReturnType< $shm_hitalama_components_demo['definition'] >
	>
	type $shm_hitalama_components_demo__extra_context_shm_hitalama_map_widget_float_application_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_application['application_context'] >
		,
		ReturnType< $shm_hitalama_components_demo['extra_context'] >
	>
	type $shm_hitalama_components_demo__source_text_shm_hitalama_map_widget_float_application_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_application['source_text'] >
		,
		ReturnType< $shm_hitalama_components_demo['source_text'] >
	>
	export class $shm_hitalama_map_widget_float_application extends $shm_hitalama_map_widget_float {
		definition( ): $shm_hitalama_map_widget_entity_custom
		application_context( ): Record<string, any>
		source_text( id: any): string
		application_content( ): readonly($mol_view)[]
		model( ): $shm_hitalama_components_demo
		content( ): ReturnType< $shm_hitalama_map_widget_float_application['application_content'] >
	}
	
}

//# sourceMappingURL=application.view.tree.d.ts.map